window.axios = require('axios');
window.axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
window.axios.defaults.headers.common['Content-Type'] = 'application/json';
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
window.axios.defaults.headers.common['Access-Control-Max-Age'] = '1728000';